/**
 * Reports a storage-layer warning to Sentry as best-effort telemetry.
 *
 * The "Missing _id / key" reports are purely diagnostic and must never block the
 * actual persistence path: if `captureErrorWithExtras` throws (e.g. logger not
 * initialised, Sentry misconfigured), the caller's subsequent write (super.set /
 * executeSql) still has to run. This wrapper guarantees that invariant.
 */
export function reportStorageWarning(message: string, error: Error, extras: Record<string, unknown>): void {
  try {
    window.logger.captureErrorWithExtras(message, error, new Map(), 'warning', extras);
  } catch {
    // Never let telemetry failures block storage writes.
  }
}
